import type { PipelineBoard, PipelineCard } from '@/pages/pipelines/common/types';

import {
  isPipelineNewInvestorParentCard,
  NEW_INVESTOR_PARENT_STAGE,
  normalizeNewInvestorParentStage,
} from './normalize-card';

const NEW_INVESTOR_PARENT_TERMINAL_STAGES = new Set(['Expired']);

export const anchorNewInvestorParentCards = (board: PipelineBoard): PipelineBoard => {
  if (!board.columns.some((column) => column.stage === NEW_INVESTOR_PARENT_STAGE)) return board;

  let changed = false;
  const anchoredParentCards: PipelineCard[] = [];

  const columns = board.columns.map((column) => {
    const cards: PipelineCard[] = [];

    column.cards.forEach((card) => {
      if (!shouldAnchorNewInvestorParent(card)) {
        cards.push(card);
        return;
      }

      const normalizedCard = normalizeNewInvestorParentStage(card);

      if (column.stage === NEW_INVESTOR_PARENT_STAGE) {
        cards.push(normalizedCard);
      } else {
        anchoredParentCards.push(normalizedCard);
      }

      changed = true;
    });

    const cardsUnchanged =
      cards.length === column.cards.length &&
      !cards.some((card, index) => card !== column.cards[index]);

    if (cardsUnchanged) return column;

    return { ...column, cards, count: cards.length };
  });

  if (anchoredParentCards.length > 0) {
    const targetColumnIndex = columns.findIndex(
      (column) => column.stage === NEW_INVESTOR_PARENT_STAGE,
    );
    columns[targetColumnIndex] = {
      ...columns[targetColumnIndex],
      cards: [...columns[targetColumnIndex].cards, ...anchoredParentCards],
      count: columns[targetColumnIndex].cards.length + anchoredParentCards.length,
    };
  }

  return changed ? { ...board, columns } : board;
};

const shouldAnchorNewInvestorParent = (card: PipelineCard) =>
  isPipelineNewInvestorParentCard(card) &&
  card.stage !== NEW_INVESTOR_PARENT_STAGE &&
  !NEW_INVESTOR_PARENT_TERMINAL_STAGES.has(card.stage);
